import { FormattedMessage, trans } from '@lingoda/i18n';
import { WarningIcon } from '@lingoda/ui/icons/lingodaIcons';
import { BannerAlert } from './styled';
import { getBrowserTranslationProps } from './utils';
import type { WellSupportedBrowser } from '../../utils';

interface Props {
    browserName: WellSupportedBrowser;
}

export const YourBrowserIsNotUpToDateToJoinClassBanner = ({ browserName }: Props) => {
    return (
        <BannerAlert
            severity={'warning'}
            title={trans(
                'your-browser-is-not-up-to-date-to-join-class-banner.title',
                {},
                'classroom-common+intl-icu',
            )}
            variant="outlined"
            icon={<WarningIcon size={24} />}
        >
            <FormattedMessage
                {...getBrowserTranslationProps(
                    browserName,
                    'your-browser-is-not-up-to-date-to-join-class-banner',
                )}
            />
        </BannerAlert>
    );
};
